function createSource(context, buffer) {
	const source = context.createBufferSource();
	source.buffer = buffer;

	const gain = context.createGain();
	gain.gain.value = 0.5;

	source.connect(gain);
	gain.connect(context.destination);

	return source;
}

function createSound(url) {
	let context;
	let source;
	let buffer;
	let isLoaded = false;
	let pendingPlay = false;

	if (typeof AudioContext !== "undefined") {
		context = new AudioContext();

		fetch(url)
			.then((res) => res.arrayBuffer())
			.then((arrayBuffer) => context.decodeAudioData(arrayBuffer))
			.then((decodedBuffer) => {
				buffer = decodedBuffer;
				source = createSource(context, buffer);
				isLoaded = true;

				if (pendingPlay === true) {
					pendingPlay = false;
					source.start();
					source = createSource(context, buffer);
				}
			})
			.catch((error) => {
				console.warn("failed to load sound", error);
			});
	}

	return {
		play() {
			if (isLoaded === false) {
				pendingPlay = true;
				return;
			}

			if (context.state === "suspended") {
				context.resume();
			}

			source.start();
			source = createSource(context, buffer);
		},
		stop() {
			pendingPlay = false;

			if (isLoaded === false) {
				return;
			}

			try {
				source.stop();
			} catch (_) {}
		}
	};
}

export default createSound;
